export default __webpack_public_path__ + "static/media/meltano-logo-white.a47a09e5.svg";